import { useEffect, useRef } from "react";
import calendarIcon from "../../assets/images/calendar.png";
import { wait } from "../../utils/genericUtils";

export default function ComingSoonSection() {
  const animation_started = useRef(false);

  useEffect(() => {
    try {
      const scriptTag = document.createElement("script");
      scriptTag.src = "https://unpkg.com/typed.js@2.1.0/dist/typed.umd.js";

      scriptTag.onload = () => {
        // Now Typed is guaranteed to be available
        // @ts-ignore (if using TS and no types installed)
        if (animation_started.current === false) {
          animation_started.current = true;
          new window.Typed("#dynamic-text", {
            strings: [
              "&lt;stream files on demand/&gt;",
              "&lt;integrate with your app/&gt;",
              "&lt;serve content globally/&gt;",
              "&lt;automate uploads/&gt;",
              "&lt;manage storage at scale/&gt;",
              "&lt;build custom workflows/&gt;",
              "&lt;power your SaaS/&gt;",
              "&lt;handle millions of files/&gt;",
            ],
            typeSpeed: 50,
            backSpeed: 25,
            loop: true,
          });
        }
      };

      document.head.appendChild(scriptTag);
    } catch (error) {
      console.error("Error loading Typed.js:", error);
    }
  }, []);

  return (
    <section id="coming-soon">
      {/* FAQ */}
      <h2 className="coming-soon-header">Developer APIs Coming Soon</h2>

      <div className="dynamic-text-container">
        <p id="dynamic-text"></p>
      </div>

      <p className="coming-soon-text">
        Our Developer APIs will give you full programmatic control over FileFreak.io, from uploading and streaming files to managing storage, setting
        permissions, and integrating with your existing workflows. Whether you’re building a SaaS product, serving game assets, or automating
        large-scale content delivery, the API is designed to make the process simple and fast. We’re still in alpha, and while there’s no exact
        release date yet, you can start using the platform today for free. Sign up, explore, and tell us what features you’d like to see. Your
        feedback will help shape the API before it goes live. A free tier will remain after launch so every developer can start building without
        limits.
      </p>
    </section>
  );
}
